<template>
    <!--弹窗-->
    <el-dialog width="70%" title="分配审核" :visible.sync="visible" :before-close="handleClose">

        <el-table
            :row-key="getRowKeys"
            v-loading="loading"
            :data="list"
            class="table_content"
            size="mini"
            border
            height="400"
            style="width: 100%; margin-top: 10px">
            <el-table-column label="选中情况" width="100" align="center">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.selected == 1"
                                 @change="changeCheckBox(scope.row, scope.$index)"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column
                label="id"
                :resizable="false"
                prop="id"
                align="center">
            </el-table-column>
            <el-table-column
                label="用户账号"
                :resizable="false"
                prop="username"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="用户名"
                :resizable="true"
                prop="full_name"
                align="center">
            </el-table-column>
        </el-table>

        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" @click="dataMigrationFunc(true)">分配审核
            </el-button>
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {
    manager_build_selection_get_own_selection_list,
    manager_build_selection_migrate_datas, manager_cost_analysis_audit_review_first
} from '@/api/advAnalys/advAnalys.js'

export default {
    data() {
        return {
            visible: false,
            tabsName: 'first',
            list: [],
            list2: [],
            selectIds: [],
            loading: false,
            selection_id: '',
            query: {
                name: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            rules: {
                name: [{required: true, message: '请输入名称', trigger: 'blur'},]
            },
        }
    },
    methods: {
        showModal(ids) {
            this.visible = true
            this.selectIds = ids
            this.getCategoryList()
        },
        changeCheckBox(data, index){
          for(const listIndex in this.list) {
            if(listIndex == index) {
              this.$set(this.list[listIndex], 'selected',1)
            } else {
              this.$set(this.list[listIndex], 'selected',0)
            }
          }
          // this.$set(this.list[index], 'selected', this.list[index].selected == 0 ? 1 : 0)
        },
        getCategoryList() {
            this.loading = true
            api.manager_index_get_developer_list().then(res => {
                if (res.code === 0) {
                    this.list = (res.data || []).map(item => {
                        item.selected = false
                        return item
                    })
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        getRowKeys(row) {
            return row.id
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        chooseItem(data) {
            this.$emit('choose1688Info', data)
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.get1688List()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.get1688List()
        },
        get1688List() {
            this.loading = true
            api.cost_analysis_personal_get_ali_result_lists({id: this.copyData.id, ...this.query}).then(res => {
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.list = responseList
                    this.query.total = res.data.total || 0
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        dataMigrationFunc() {
            let ids = []
            this.list.forEach(item => {
                item.selected && ids.push(item.id)
            })
            if (ids.length == 0) {
                this.$message({type: 'error', message: '暂未选择人员'})
                return
            }
            let params = {
                ids: this.selectIds,
                developer_id: ids.toString(),
            }
            api.manager_cost_analysis_audit_review_first(params).then(res => {
                if (res.code === 0) {
                    this.$message.success(res.data)
                    this.handleClose(true)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(flag) {
            this.visible = false
            this.tabsName = 'first'
            this.list = []
            this.selectIds = ''
            this.$emit('refreshPage', flag)
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
